import { styled } from 'styled-components'

// Self-contained on purpose (no .scss): this view also renders into the static
// fatal-error document, which only gets ServerStyleSheet-inlined styles.
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;
  margin: 0 auto;
  border-radius: 5px;
  line-height: 3;
  text-align: center;
  box-shadow: 0 9px 11px rgba(0, 0, 0, 0.01);
  background-color: white;

  @media (min-width: 1024px) {
    width: 850px;
    height: 600px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export const Title = styled.div`
  font-size: 22px;
  line-height: 28px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black};
`

export const Description = styled.div`
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.black};
`

export const TryAgainButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 250px;
  height: 56px;
  border-radius: 5px;
  cursor: pointer;
  color: rgb(255, 255, 255);

  svg {
    margin-right: 9px;
  }
`

export const TryAgainText = styled.div`
  font-size: 20px;
  font-weight: 700;
`

export const TalkToUsContainer = styled.div`
  position: absolute;
  bottom: 50px;
`
